'use client'

import React from 'react'
import { BlogSliderProps } from './types'
import SwiperComponent from '../../Swiper'
import BlogCard from '../BlogCard'

const BlogSlider = ({ content, blogItems }: BlogSliderProps) => {
    return (
        <SwiperComponent
            isBlogSlider
            content={content}
            slides={blogItems?.map(blog => (
                <BlogCard inSlider {...blog} />
            ))}
        />
    )
}

export default BlogSlider
